var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 opensans",attrs:{"id":"app"}},[_c('router-view',{staticClass:"min-vh-100 mw8 center",attrs:{"id":"router-view"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }